import styled, { css } from 'styled-components';
import {
  borderDangerBase,
  helpTextDanger,
  helpTextDefault,
  inputBorderRest,
} from 'styles/variables';
import { placeholderTextDefault } from 'styles/variables/colors';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  font-family: inherit;
`;

export const ComboboxContainer = styled.div<{ hasError?: boolean }>`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  box-shadow: none;
  border: 1px solid
    ${({ hasError }) => (hasError ? borderDangerBase : inputBorderRest)};
  height: 40px;
  &::placeholder {
    color: ${({ theme }) => theme.configs.tertiaryBox.mainFontColor};
  }
  background-color: #ffffff;
  position: relative;
`;

export const ComboboxWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

interface ComboboxInputProps {
  readOnly?: boolean;
}

export const ComboboxInput: React.FC<ComboboxInputProps> =
  styled.input<ComboboxInputProps>`
    color: rgb(51, 51, 51);
    align-items: center;
    display: flex;
    flex: 1;
    flex-wrap: wrap;
    overflow: hidden;
    padding: 2px 8px;
    box-sizing: border-box;
    border: none;
    border-radius: 4px;
    height: 100%;
    font-size: 14px;

    ::placeholder {
      color: ${placeholderTextDefault};
    }
  ` as any;

export const ComboboxToggleButton = styled.button`
  all: unset;
  align-items: center;
  align-self: stretch;
  display: flex;
  flex-shrink: 0;
  box-sizing: border-box;
  padding: 2px 6px;
  color: ${({ theme }) => theme.configs.tertiaryBox.mainFontColor};
  background-color: transparent;
`;

export const ComboboxMenu = styled.ul<{ isOpen?: boolean }>`
  all: unset;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 1000;
  margin-top: 4px;
  background-color: ${({ theme }) => theme.configs.tertiaryBox.bgColor};
  border: 1px solid ${inputBorderRest};
  border-radius: 8px;
  box-shadow: 0 0 10px 0
    ${({ theme }) => theme.configs.tertiaryBox.secondaryFontColor};
  max-height: 200px;
  overflow-y: auto;
  width: 100%;
  ${({ isOpen }) =>
    !isOpen &&
    css`
      display: none;
    `}
`;

export const ComboboxItem = styled.li<{
  isHighlighted?: boolean;
  isSelected?: boolean;
}>`
  padding: 8px 12px;
  font-size: 14px;
  line-height: 1.5;
  cursor: pointer;
  display: flex;

  ${({ isSelected }) =>
    isSelected &&
    css`
      color: ${({ theme }) => theme.configs.tertiaryBox.secondaryFontColor};
    `}

  ${({ isHighlighted }) =>
    isHighlighted &&
    css`
      background-color: ${({ theme }) => theme.configs.mainBox.bgColor};
      color: ${({ theme }) => theme.configs.tertiaryBox.secondaryFontColor};
    `}
`;

export const ComboboxNoResults = styled.div`
  display: block;
  padding: 12px 16px;
  font-size: 14px;
  color: ${({ theme }) => theme.configs.tertiaryBox.secondaryFontColor};
  background-color: ${({ theme }) => theme.configs.tertiaryBox.bgColor};
  text-align: center;
`;

export const ComboboxHelperText = styled.div<{
  isError?: boolean;
  size?: 'sm' | 'lg' | 'md';
}>`
  align-items: center;
  align-self: stretch;
  display: flex;
  flex-shrink: 0;
  box-sizing: border-box;
  padding: 2px 6px;
  color: ${({ theme }) => theme.configs.tertiaryBox.mainFontColor};
  color: ${({ isError }) => {
    if (isError) {
      return helpTextDanger;
    }

    return helpTextDefault;
  }};

  ${({ size }): string => {
    switch (size) {
      case 'sm':
        return `
          font-size: 10px;
          line-height: 15px;
        `;
      case 'lg':
        return `
          font-size: 16px;
          line-height: 21px;
        `;
      case 'md':
      default:
        return `
          font-size: 14px;
          line-height: 1.5;
        `;
    }
  }}
`;
